import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Impressum: React.FC = () => {
  useEffect(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    // Clean up function to remove the meta tag when component unmounts
    return () => {
      const existingTag = document.querySelector('meta[name="robots"]');
      if (existingTag) {
        document.head.removeChild(existingTag);
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h1 className="text-2xl font-bold text-deep-blue mb-6">Impressum</h1>
          
          <p className="mb-4">AdressFinder.org ist eine Plattform der:</p>
          
          <div className="mb-6">
            <p className="font-semibold">YN Digital GmbH</p>
            <p>Am Schulhof 23</p>
            <p>28865 Lilienthal</p>
            <p>Handelsregister: HRB 211416</p>
            <p>Registergericht: Amtsgericht Walsrode</p>
          </div>
          
          <div className="mb-6">
            <p className="font-semibold">Vertreten durch:</p>
            <p>Yannic Neubauer (Adresse wie oben)</p>
          </div>
          
          <h2 className="text-xl font-semibold text-deep-blue mt-8 mb-4">Kontakt</h2>
          <p>E-Mail: <a href="mailto:info@adressfinder.org" className="text-blue-600 hover:underline">info@adressfinder.org</a></p>

          <h2 className="text-xl font-semibold text-deep-blue mt-8 mb-4">Umsatzsteuer-ID</h2>
          <p className="mb-2">Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
          <p>DE364640255</p>
          
          <h2 className="text-xl font-semibold text-deep-blue mt-8 mb-4">Redaktionell verantwortlich</h2>
          <p>Yannic Neubauer (Adresse wie oben)</p>
          
          <h2 className="text-xl font-semibold text-deep-blue mt-8 mb-4">EU-Streitschlichtung</h2>
          <p className="mb-4">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="http://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">http://ec.europa.eu/consumers/odr/</a></p>
          <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          
          <div className="mt-8">
            <Link to="/" className="text-blue-600 hover:underline">Zurück zur Startseite</Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Impressum; 